export default "__VITE_ASSET__Dd4YWr8A__"